<template>
	<div class="wrap addr-wrap flex-column">
		<mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
		<div class="flex-item" v-if="!load">
			<div class="seladdress-list">
				<div  class="address-item" >
					<table>
						<tr v-for="(address,index) in addressInfo">
							<td>
								<mu-radio name="group" :nativeValue="address.addressId" v-model="selectAddressId" class="list-radio  floatL" v-bind:class="[address.addressId==selectAddressId? 'primary' : '']" @change="selectAddr(address.addressId)"/>
							</td>
							<td>
								<div class="user-box" @click="selectAddr(address.addressId)">
									<p class="address"><label v-if="address.isDefault=='1'" class="orange">[默认地址]</label>{{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp;{{address.area}}&nbsp;&nbsp;{{address.address}}</p>
									<p class="user"><label>{{address.consignee}}</label><label class="fr">{{address.mobile}}</label></p>
								</div>
							</td>
							<td>
								<div class="operate"  @click="editAddress(address.addressId)">
									<img class="" src="/static/images/icon_edit.png">
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>

			<div class="addaddr" @click="add">
				新增收货地址
				<img class="fr" src="/static/images/ic_add_address_3x.png">
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import {mapActions} from 'vuex';
	import { storage } from "@common/utils/util.js";

	export default{
		data () {
		    return {
		    	load:true,
		        addressInfo:[],//地址列表
				selectAddressId:this.$route.query.selectAddressId, //选中的地址id

		    }
	 	},
	 	watch: {//深度 watcher
		   
		},
		created(){
			 //获取地址信息
		    this.getListAddress();
		},
	 	methods: {
	 		 ...mapActions({
			      listAddress: 'listAddress', //获取地址列表
			 }),
	 		// 获取地址列表
		    getListAddress(){
		    	this.listAddress().then(res=>{
	        		this.addressInfo = res;
	        		this.load = false;
	        	})
		    },
	 		//选中后直接返回订单提交页面
	 		selectAddr(id){
	 			if(this.$route.query.orderId == undefined){
	 				this.$router.push({
		    		path: '/main/firmorder?selectAddressId='+id
		    	})
	 			}else{
	 				this.$router.push({
	 					path: '/main/firmorder?orderId='+this.$route.query.orderId+'&selectAddressId='+id
	 				})
	 			}
	 			// this.$router.push({
		   //  		path: '/main/firmorder?selectAddressId='+id
		   //  	})
	 		},
	  		//修改地址
			editAddress(id){
		    	this.$router.push({
		    		path: '/main/writeaddress?addressId='+id
		    	})
		    },
		    //新增地址
		    add(){
		    	this.$router.push({
		    		path: '/main/writeaddress'
		    	})
		    },
		},
	  	components:{
	  		
	  	}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'src/views/personal/personal.scss';
	.addr-wrap{
		.seladdress-list{
				@include font-dpr(12px);
				.address-item{
					margin-bottom: 1px;
					background: #fff;
					table{
						width: 100%;
					}
					tr{
						border-bottom: 1px solid #e5e5e5 ;
					}
					td{
						padding: 0.3rem 0rem  0.3rem 0rem;
					}
					td:first-child{
						padding-left: 0.35rem;
						width: 1.2rem;
					}
					td:last-child{
						width: 1.5rem;
					}
					.list-radio{
						height: auto;
						min-width: 0.85rem;
					}
					.user-box{
						.address{
							color: #646464;
							line-height: 1.5;

						}
						.user{
							color: #323232;
							padding-top: 0.25rem;
						}

					}
					.operate{
						position: relative;
						margin-left: 0.65rem;
						/*border-left: 1px solid #DDDDDD ;*/
						padding:0 0.5rem;
						text-align: right;
						&:before{
							content: "";
							display: inline-block;
							width: 1px;
							height: 160%;
							position: absolute;
							top: -20%;
							left: 0rem;
							background: #E5E5E5;
						}
						img{
							width: 0.6rem;
							height: 0.6rem;
							
						}
					}

				}
		}
		.addaddr{
			padding: 0 0.35rem;
		    height: 1.0rem;
		    line-height: 1rem;
		    background: #fff;
		    margin-top: 0.35rem;
		    img{
		    	width: 0.5rem;
		    	margin-top: 0.25rem;
		    }
		}
	}
	
</style>


// WEBPACK FOOTER //
// selectaddress.vue?99409306